import { useQuery } from "@apollo/client";
import { useEffect, useState } from "react";
import { SEARCH_POSTAL_CODES } from "../graphql/address-gql";
import { NamedEntity } from "../types/common";
import { castToNumber } from "../utils/commons";

export const formatPostalCode = (value?: string) => value?.length === 6
  ? value.slice(0, 3) + ' ' + value.slice(3)
  : value ?? '';

export const getPostalCode = (postalCodes: NamedEntity[], id?: number) =>
  id ? postalCodes.find(pc => +pc.id === castToNumber(id))?.name : undefined;

export default function usePostalCode(): [
  postalCodes: NamedEntity[]
] {
  const { data } = useQuery<{ postalCodes: NamedEntity[] }>(SEARCH_POSTAL_CODES);

  const [postalCodes, setPostalCodes] = useState<NamedEntity[]>([]);

  useEffect(() => {
    const results = data?.postalCodes
      .map(item => (
        {
          id: item.id,
          name: formatPostalCode(item.name)
        }
      ))
      .sort((a, b) => a.name.localeCompare(b.name));
    setPostalCodes(results ?? []);
  }, [data]);

  return [postalCodes];
}
